export enum EnvelopeStatus {
  sending = 'sending',
  sent = 'sent',
  voided = 'voided',
  completed = 'completed',
  partiallySigned = 'partiallySigned',
  notFinalized = 'notFinalized',
  created = 'created',
  declined = 'declined',
}

export const EnvelopeStatusLabels: Record<
  Exclude<
    EnvelopeStatus,
    | EnvelopeStatus.created
    | EnvelopeStatus.notFinalized
    | EnvelopeStatus.sending
  >,
  string
> = {
  completed: 'Signed',
  declined: 'Declined',
  voided: 'Voided',
  sent: 'Not Signed',
  partiallySigned: 'Partially Signed',
};

export enum RecipientStatus {
  autoresponded = 'autoresponded',
  completed = 'completed',
  created = 'created',
  declined = 'declined',
  delivered = 'delivered',
  faxpending = 'faxpending',
  sent = 'sent',
}
